export default __webpack_public_path__ + "static/media/Brassart of Vicious Frenzy.f2b25930.jpg";